import React, { PureComponent } from 'react';
import b from 'b_';

import './event-item-vertical.css';

import { Event } from '@interfaces/outreach-entity';

const class_ = b.with('event-item-vertical');

interface Props {
    entity: Event;
    isCompleted: boolean;
    dateInterval: string;
}

export default class EventItemVertical extends PureComponent<Props> {
    public render() {
        const { entity, dateInterval, isCompleted } = this.props;
        const { isPinned, image, title, shortDescription, link, place } = entity;

        return (
            <div className={class_({ pinned: isPinned, completed: isCompleted })}>
                <a className={class_('image-wrap')} href={link}>
                    <div
                        className={class_('image')}
                        style={{ backgroundImage: `url(${image || '/no-record.png'})` }}
                    />
                </a>

                <div className={class_('info')}>
                    <a className={`${class_('date-interval')} link_black`} href={link}>
                        {dateInterval}
                    </a>
                    <a className={class_('title')} href={link}>
                        {title}
                    </a>
                    {Boolean(shortDescription) && (
                        <div className={class_('description')}>
                            {shortDescription}...<a className={`${class_('more')} link_black`} href={link}>
                                more
                            </a>
                        </div>
                    )}

                    <div className={class_('bottom')}>
                        <div className={class_('city')}>
                            {place}
                        </div>
                        {isCompleted && (
                            <a className={class_('materials')} href={link}>
                                Materials
                            </a>
                        )}
                    </div>
                </div>
            </div>
        );
    }
}
